import { WhoWeAre } from './WhoWeAre'

export default WhoWeAre
